import { ReactComponent as Normal } from "components/icons/unliked.svg";
import { ReactComponent as Filled } from "components/icons/likeIcon.svg";

interface IProps {
  active?: boolean;
}

export const HeartIcon = (props: IProps): JSX.Element => {
  if (props.active) {
    return (
      <Filled className="HeartIcon filled" />
    );
  }

  return (
    <Normal className="HeartIcon normal" />
  );
};
